import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'oc-not-found',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: ` NOT FOUND `,
  styles: `
    
  `,
})
export class NotFoundComponent {}
